import "./App.css";
import * as React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {connect} from "react-redux";
import {Box, styled, ThemeProvider} from "@mui/material";
import WTNavBar from "./components/navigation/NavBar";
import WTAlert from "./components/alert/Alert";
import {routes} from "./routing/Routes";
import {ILanguageTokens} from "./localization/LanguageTokens";
import {IK_CONTEXT_URL_ENDPOINT, PERSONAL_PROJECTS} from "./Config";
import {IKContext} from 'imagekitio-react'
import {createAppTheme} from "./theme/AppTheme";
import Contact from "./pages/Contact";
import LegalNotice from "./pages/LegalNotice";
import ProjectPage from "./pages/ProjectPage";
import Home from "./pages/Home";
import {RootState} from "./redux/store";
import Footer from "./AppFooter";
import DefaultLanguageRedirect from "./routing/DefaultLanguageRedirect";
import LanguageHandler from "./localization/LanguageHandler";
import ScrollToTop from "./components/scroll/ScrollToTop";
import Career from "./pages/Career";

const AppContainer = styled(Box)<{ $isDark: boolean }>(({$isDark, theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    //height: 'fit-content',
    flex: "1",
    paddingTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    justifyContent: 'center',
    // overflow: 'auto',
    // margin: 0,
    //marginTop: theme.spacing(4),
    backgroundImage: $isDark ? 'linear-gradient(to bottom, #222222, #111111)' : "linear-gradient(to bottom, #fff6f0, #fff6e7, #fff5e3, #fff3e0, #fff2dc, #ffeddf, #ffeae8)", //, #ffe9f4, #ffeaff)",
}));


// todo react helmet header tags
// todo security xss
// ToDo button types
// todo test on ios, edge, safari
// todo SEO homepage 3D
// todo ksp

// Optional
// Css Animations: blob button: https://webdeasy.de/en/top-css-buttons-en/ &&  Button bubble effect && Blobs button
//     text animation  https://codepen.io/cesar2535/pen/ByYXpN

interface IProps {
    languageTokens: ILanguageTokens
    isDark: boolean;
}

function App({isDark, languageTokens}: IProps) {

    return (
        <ThemeProvider theme={createAppTheme(isDark)}>
            <BrowserRouter>
                <IKContext urlEndpoint={IK_CONTEXT_URL_ENDPOINT}>
                    <WTNavBar/>
                    <WTAlert/>
                    <AppContainer
                        id={'AppContainer'}
                        $isDark={isDark}
                        // className={`height-moz-available pane scroller`}
                    >
                        <ScrollToTop/>
                        <Routes>
                            <Route path="/" element={<DefaultLanguageRedirect/>}/>
                            <Route path="/:lang" element={<LanguageHandler/>}>
                                <Route path={routes.contact} element={<Contact/>}/>
                                <Route path={routes.legalNotice} element={<LegalNotice/>}/>
                                {PERSONAL_PROJECTS(languageTokens).map((p, index) =>
                                    <Route
                                        key={p.mediaCardElement.name}
                                        path={p.mediaCardElement.route}
                                        element={<ProjectPage languageTokens={languageTokens} projectIndex={index}/>}
                                    />)
                                }
                                <Route path={routes.career} element={<Career/>}/>
                                <Route index element={<Home/>}/>
                            </Route>
                        </Routes>
                        <Footer/>
                    </AppContainer>
                </IKContext>
            </BrowserRouter>
        </ThemeProvider>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
    isDark: state.theme.isDark,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(App);
